import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthRoutingModule } from './auth-routing.module';
import { AcceptTermsComponent } from './components/accept-terms/accept-terms.component';
import { LoginComponent } from './components/login/login.component';
import { TruncateStringPipe } from './helpers';
import { AuthenticationService } from './services/authentication.service';
import { SSOErrorInterceptor } from './helpers/ssoerror.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SSOTokenInterceptor } from './helpers/ssotoken.interceptor';
import { TidLogoutComponent } from './components/tid-logout/tid-logout.component';
import { MarketingFooterComponent } from './components/marketing-footer/marketing-footer.component';
import { SharedModule } from '../shared-module/shared.module';
import { MatStepperModule } from '@angular/material/stepper';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { SignupService } from './services/signup.service';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { CheckEmailComponent } from './components/sign-up/check-email/check-email.component';
import { AccountInformationComponent } from './components/sign-up/account-information/account-information.component';
import { BillingSignupComponent } from './components/sign-up/billing-signup/billing-signup.component';
import { FeatureComponent } from './components/sign-up/feature/feature.component';
import { DynamicFormComponent } from './components/sign-up/dynamic-form/dynamic-form.component';
import { ReviewSignupComponent } from './components/sign-up/review-signup/review-signup.component';

const maskConfig: Partial<IConfig> = {
  validation: false,
};
@NgModule({
  declarations: [
    LoginComponent,
    AcceptTermsComponent,
    TruncateStringPipe,
    FeatureComponent,
    TidLogoutComponent,
    MarketingFooterComponent,
    SignUpComponent,
    CheckEmailComponent,
    AccountInformationComponent,
    DynamicFormComponent,
    BillingSignupComponent,
    ReviewSignupComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AuthRoutingModule,
    SharedModule,
    MatStepperModule,
    NgxMaskModule.forRoot(maskConfig),
  ],
  providers: [
    AuthenticationService,
    SignupService,
    { provide: HTTP_INTERCEPTORS, useClass: SSOErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SSOTokenInterceptor, multi: true },
  ],
})
export class AuthModule {}
